<template>
  <!-- 品牌红包抽奖 -->
  <van-popup v-model="showLottery" :close-on-click-overlay="false" @click-overlay="$emit('close')" :lock-scroll="false">
    <!-- 中奖 -->
    <div class="logo-prize" v-if="lotteryResult.category !== 'thanks'">
      <!-- 现金 -->
      <div class="logo-title"></div>
      <div v-if="lotteryResult.category === 'redpack'">
        <div class="red-box">
          <div class="logo-money">{{ lotteryResult.value }}元</div>
          <img src="@this/assets/image-11.png" @click="$emit('close')" class="red-btn" />
        </div>
        <img :src="prizePicture" alt="" class="logo-coupon" />
      </div>
      <div v-if="lotteryResult.category === 'code'">
        <div class="red-box">
          <div class="logo-special">{{ lotteryResult.name }}</div>
          <div class="logo-num">兑换码：{{ lotteryResult.value }}</div>
          <img src="@this/assets/image-11.png" @click="$emit('close')" class="red-btn" />
        </div>
        <img :src="prizePicture" alt="" class="logo-coupon" />
      </div>
      <!-- 链接 -->
      <div class="link" v-if="lotteryResult.category === 'link'">
        <div class="link-box">
          <div class="logo-link">{{ lotteryResult.name }}</div>
          <img src="@this/assets/image-10.png" @click="$emit('clickConfirm')" class="link-btn" />
        </div>
        <img :src="prizePicture" alt="" class="logo-coupon" />
      </div>
    </div>
    <!-- 未中奖 -->
    <div class="logo-no" v-else>
      <div class="thanks-title"></div>
      <div class="text">很遗憾,未中奖</div>
      <img src="@this/assets/image-11.png" @click="$emit('close')" class="thanks-btn" />
      <img :src="prizePicture" alt="" class="logo-coupon" />
    </div>
    <div @click="$emit('close')" class="popup-close-blue"></div>
  </van-popup>
</template>

<script>
import { Popup } from 'vant';
export default {
  props: {
    showPrize: {
      type: Boolean,
      default: false,
    },
    lotteryResult: {
      type: Object,
      default() {
        return {};
      },
    },
    prizePicture: {
      type: String,
      default() {
        return '';
      },
    },
  },
  computed: {
    showLottery: {
      get() {
        return this.showPrize;
      },
      set(value) {
        this.$emit('close', value);
      },
    },
  },
  components: {
    [Popup.name]: Popup,
  },
};
</script>
<style lang="scss" scoped>
// .type {
//   background-image: -webkit-linear-gradient(top, #bce7fd, #30a2f1);
//   -webkit-background-clip: text;
//   -webkit-text-fill-color: transparent;
// }
.logo-no-count {
  background-size: 100% 100%;
  width: 617px;
  height: 480px;
  position: relative;
  img {
    width: 347px;
    height: 103px;
    position: absolute;
    left: 118px;
    top: 320px;
  }
}
.logo-box {
  background-size: 100% 100%;
  width: 617px;
  height: 480px;
  position: relative;
  img {
    width: 347px;
    height: 103px;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    top: 320px;
  }
}
.logo-no {
  background: url(~@this/assets/image-09.png) no-repeat;
  background-size: 100% 100%;
  width: 590px;
  height: 612px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .thanks-title {
    font-weight: 800;
    font-size: 50px;
    position: absolute;
    left: 50%;
    top: 40px;
    letter-spacing: 3px;
    transform: translate(-50%);
    width: 245px;
    height: 54px;
    background: url(~@this/assets/image-26.png) no-repeat;
    background-size: 100% 100%;
  }
  .text {
    margin-top: 170px;
    color: #fe293f;
    font-size: 55px;
    font-weight: 600;
    letter-spacing: 4px;
  }
  .thanks-btn {
    position: absolute;
    left: 50%;
    top: 250px;
    transform: translate(-50%);
    width: 338px;
    height: 100px;
  }
  .logo-coupon {
    width: 550px;
    height: 218px;
    position: absolute;
    left: 50%;
    top: 360px;
    transform: translate(-50%);
  }
}
.logo-prize {
  background: url(~@this/assets/image-09.png) no-repeat;
  background-size: 100% 100%;
  width: 590px;
  height: 612px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  .logo-title {
    font-weight: 800;
    font-size: 50px;
    position: absolute;
    left: 50%;
    top: 40px;
    letter-spacing: 3px;
    transform: translate(-50%);
    width: 280px;
    height: 54px;
    background: url(~@this/assets/image-25.png) no-repeat;
    background-size: 100% 100%;
  }
  .red-box {
    border-radius: 10px;
    width: 100%;
    height: 260px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    left: 50%;
    top: 120px;
    transform: translate(-50%);
    .red-btn {
      position: absolute;
      left: 50%;
      top: 130px;
      transform: translate(-50%);
      width: 338px;
      height: 100px;
    }
  }
  .logo-money {
    margin-top: 40px;
    font-weight: 600;
    color: #fe293f;
    font-size: 75px;
    letter-spacing: 4px;
  }
  .logo-special {
    margin-top: 10px;
    font-weight: 600;
    color: #fe293f;
    font-size: 65px;
    letter-spacing: 4px;
  }
  .logo-num {
    margin-top: 10px;
    color: #aa1100;
    font-size: 35px;
  }
  .logo-coupon {
    width: 550px;
    height: 218px;
    position: absolute;
    left: 50%;
    top: 365px;
    transform: translate(-50%);
  }
  .link {
    .link-box {
      border-radius: 10px;
      width: 100%;
      height: 260px;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: absolute;
      left: 50%;
      top: 120px;
      transform: translate(-50%);
      .logo-link {
        margin-top: 45px;
        font-size: 58px;
        font-weight: 600;
        color: #fe293f;
      }
      .link-btn {
        position: absolute;
        left: 50%;
        top: 130px;
        transform: translate(-50%);
        width: 338px;
        height: 100px;
      }
    }
  }
}
</style>
